import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';
let targetContainer = document.getElementById('quote-calculator-x');
if(targetContainer){
	ReactDOM.render(<App />, targetContainer);
}

if (module.hot) {
    module.hot.accept();
  }
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js